import { Avatar } from '@mui/material';
import { useRecordContext } from 'react-admin';
import { type AnimationLight, type AnimationSummary } from '@wwf/sdk';
import { useResource } from '@app/misc/useResource';

export interface AnimationAvatarProps {
    record?: AnimationSummary | AnimationLight;
    width?: number;
    height?: number;
    variant?: 'sm' | 'md' | 'lg' | 'xl';
    style?: React.CSSProperties;
    title?: string;
}

const sizes = {
    sm: 30,
    md: 40,
    lg: 80,
    xl: 120,
} as const;

export const AnimationAvatar = (props: AnimationAvatarProps) => {
    const record = useRecordContext<AnimationSummary | AnimationLight>(props);
    const { data: src } = useResource(record?.image?.id);

    const { width, height, variant = 'md', style, title } = props;

    const _width = width ?? sizes[variant];
    const _height = height ?? sizes[variant];

    return (
        <Avatar
            variant="rounded"
            title={title}
            sx={{ ...style, width: _width, height: _height, borderRadius: 2 }}
            src={src ?? undefined}
        >
            {src ? (
                <img src={src} alt={record?.name ?? ''} />
            ) : (
                (record?.name ?? '').charAt(0).toUpperCase()
            )}
        </Avatar>
    );
};
